import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { BusinessHours } from 'components/VehiclesGroups';

const EditBusinessHoursRulesetsModal = ({ open, handleClick, currentVehicleGroup }) => {
  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={i18n.t('vehicle_groups.business_hours.edit_business_hours')}
    >
      <BusinessHours currentGroup={currentVehicleGroup} />
    </BaseModal>
  );
};
EditBusinessHoursRulesetsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  currentVehicleGroup: PropTypes.object.isRequired,
};
EditBusinessHoursRulesetsModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default EditBusinessHoursRulesetsModal;
